import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from '../../grid';
import { P } from '../../typography';
import { TableTemplate } from '..';

const Table = ({ headers, data }) => (
  <TableTemplate headers={headers}>
    {data.map(row => (
      <tr data-testid="table-id" key={JSON.stringify(row)}>
        {map(row, (value, key) => (
          <td key={`${key}-${value}`}>
            <Flex width="100%">
              <P>{value}</P>
            </Flex>
          </td>
        ))}
      </tr>
    ))}
  </TableTemplate>
);

Table.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export { Table };
